module.exports = __webpack_public_path__ + "img/2022WomanLikeNoOther.fc5e6e77.jpg";